import React from 'react';
import { Item as StyledItem } from '../styles/StyledComponents';
import { Item as ItemType } from '../hooks/useGame';

interface ItemProps {
  item: ItemType;
}

const Item: React.FC<ItemProps> = ({ item }) => {
  return (
    <StyledItem 
      position={item.position} 
      type={item.type} 
    />
  );
};

export default Item;
